import { render } from "./ListingOrganicCvrCard.vue?vue&type=template&id=b6a3fc3c"
import script from "./ListingOrganicCvrCard.vue?vue&type=script&lang=js"
export * from "./ListingOrganicCvrCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__